import { EnemyType } from '../configs/enemies';
import { ReactComponent as StarIcon } from '../assets/star.svg';

type Props = Pick<
  EnemyType,
  'type' | 'name' | 'description' | 'points' | 'icon'
>;
export function EnemyInfo({
  type,
  name,
  description,
  points,
  icon: Icon,
}: Props) {
  return (
    <div className="w-40 xl:w-48">
      <div className="w-9/12 h-32 xl:h-40 m-auto flex items-center">
        <Icon className="w-full" />
      </div>
      <div
        className={`relative flex items-center justify-center mb-2 xl:mb-4 text-${type}`}
      >
        <span className="text-current text-lg xl:text-xl mr-2">{name}</span>
        <Points points={points} type={type} />
      </div>
      <p className="text-xs text-gray-700 text-center">{description}</p>
    </div>
  );
}

function Points({ points, type }: Pick<Props, 'points' | 'type'>) {
  return (
    <div className="relative w-20 h-20 xl:w-24 xl:h-24 text-white">
      <StarIcon className="w-20 h-20 xl:w-24 xl:h-24" />
      <span
        className={`text-current text-xl font-bold absolute inset-0 flex justify-center items-center text-${type} xl:pt-2`}
      >
        {points}p
      </span>
    </div>
  );
}
